import { Component, OnInit } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from 'models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';
import { NumberAttributeFilter } from 'app/shared/ui/models/number-attribute-filter';
import { StringAttributeFilter } from 'app/shared/ui/models/string-attribute-filter';
import { DateAttributeFilter } from 'app/shared/ui/models/date-attribute-filter';
import { TransporterMemberAttributeFilter } from 'app/shared/ui/models/transporter-member-attribute-filter';
import { PaiementMethodAttributeFilter } from 'app/shared/ui/models/paiement-method-attribute-filter';
import { DeliveryStatusAttributeFilter } from '../../../../ui/models/delivery-status-attribute-filter';
import { DatetimeAttributeFilter } from '../../../../ui/models/datetime-attribute-filter';
import { RefundedStatusAttributeFilter } from '../../../../ui/models/refunded-status-attribute-filter';
import { PaymentStatusAttributeFilter } from '../../../../ui/models/payment-status-attribute-filter';
import { SalesSupportActionsAttributeFilter } from '../../../../ui/models/sales-support-actions-attribute-filter';

@Component({
  selector: 'jhi-bary-modal-filters',
  templateUrl: './bary-modal-filters.component.html',
})
export class BaryModalFiltersComponent implements OnInit {
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  title: string | undefined;
  errors: string[] = [];
  options?: AttributeFilter[];
  filters?: {};
  class = '';
  loaded = false;

  constructor(public modalRef: MDBModalRef) {}

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  ngOnInit(): void {
    this.loaded = true;
  }

  isNumberFilter(filter: AttributeFilter): boolean {
    return filter instanceof NumberAttributeFilter;
  }

  isStringFilter(filter: AttributeFilter): boolean {
    return filter instanceof StringAttributeFilter;
  }

  isDateFilter(filter: AttributeFilter): boolean {
    return filter instanceof DateAttributeFilter;
  }

  isCommercialFilter(filter: AttributeFilter): boolean {
    return filter instanceof TransporterMemberAttributeFilter;
  }

  isPaymentMethodFilter(filter: AttributeFilter): boolean {
    return filter instanceof PaiementMethodAttributeFilter;
  }

  isDeliveryStatusFilter(filter: AttributeFilter): boolean {
    return filter instanceof DeliveryStatusAttributeFilter;
  }

  isRefundedStatusFilter(filter: AttributeFilter): boolean {
    return filter instanceof RefundedStatusAttributeFilter;
  }

  isSalesSupportActionsAttributeFilter(filter: AttributeFilter): boolean {
    return filter instanceof SalesSupportActionsAttributeFilter;
  }

  isPaymentStatusFilter(filter: AttributeFilter): boolean {
    return filter instanceof PaymentStatusAttributeFilter;
  }

  submit(): void {
    this.action.next(new BaryModalEvent({ submit: true, value: this.filters }));
    this.modalRef.hide();
  }

  isDateTimeFilter(filter: AttributeFilter): boolean {
    return filter instanceof DatetimeAttributeFilter;
  }
}
